export default __webpack_public_path__ + "static/media/spin1.69cfbc2c.gif";